import { OutlookTeachingBubble } from "owa-lightning-views";
import { DirectionalHint } from "@fluentui/react/lib/Callout";
import type { Target } from "@fluentui/react";
import { observer } from "owa-mobx-react";
import { lightable } from "owa-lightning-v2";
import { lighted } from "owa-lightning-core-v2";
import type { LightningProps } from "owa-lightning-core-v2";
import loc, { formatToArray } from "owa-localize";
import React from "react";
import { CopilotPrioritizeOnboardedCalloutTitle, CopilotPrioritizeOnboardedCalloutDesc, CopilotPrioritizeOnboardedCalloutGotItButtonText, } from "./CopilotPrioritizeOnboardedCallout.locstring.json";
import { CopilotInboxPriorityIcon } from "owa-mail-copilot-inbox-shared";

interface CopilotPrioritizeOnboardedCalloutProps extends LightningProps {
    target: Target;
}

const CopilotPrioritizeOnboardedCallout = (props: CopilotPrioritizeOnboardedCalloutProps) => {
    const { target, id } = props;
    
    const onGotItButtonClicked = React.useCallback(() => {
        lighted(id);
    }, [id]);
    
    const calloutDescription = React.useMemo(() => {
        return (<div>
                {formatToArray(loc(CopilotPrioritizeOnboardedCalloutDesc), <CopilotInboxPriorityIcon priorityOverride="high" scenario="OnboardedCallout"/>)}
            </div>);
    }, []);
    
    return (<OutlookTeachingBubble target={target} directionalHint={DirectionalHint.rightCenter} calloutTitle={loc(CopilotPrioritizeOnboardedCalloutTitle)} calloutDescription={calloutDescription} primaryButtonText={loc(CopilotPrioritizeOnboardedCalloutGotItButtonText)} lightningId={id} gotItButtonOnClick={onGotItButtonClicked}></OutlookTeachingBubble>);
};

const defaultExport: React.ComponentType<CopilotPrioritizeOnboardedCalloutProps & LightningProps> = lightable(observer(CopilotPrioritizeOnboardedCallout, "CopilotPrioritizeOnboardedCallout"));
export default defaultExport;
